import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { IGetNombreColumnas } from '../../../../shared/interfaces/database/formulario';
import { IColumnDinamico } from '../../../../shared/interfaces/database/tramites_automaticos';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

export interface LlavesConfig {
  campoFormulario: string;
  campoTablaDinamica: string;
}

@Component({
  selector: 'app-act-automatica-llaves-config',
  standalone: true,
  imports: [DropdownModule, ButtonModule, TableModule, FormsModule, TooltipModule, CommonModule, TranslateModule],
  template: `
  <div class="flex flex-column gap-2 w-full">
      <div class="flex justify-content-between align-items-center mb-2">
        <label class="ml-3 font-bold">
            {{'msg.configuracionLlaves' | translate}}
        </label>
        <button pButton type="button" icon="pi pi-plus" [outlined]="true"
          iconPos="left" class="p-button-primary w-4rem" (click)="add()"></button>
      </div>
      <div>
        <p-table [value]="llavesConfig" [tableStyle]="{'min-width': '50rem'}" [scrollable]="true">
          <ng-template pTemplate="header">
            <tr>
              <th class="text-left color-blue-2 font-13 font-bold">{{'common.campoFormulario' | translate}}</th>
              <th class="text-left color-blue-2 font-13 font-bold">{{'common.campoTablaDinamica' | translate}}</th>
              <th class="text-left color-blue-2 font-13 font-bold" style="width: 5rem"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
            <tr [ngClass]="{'invalid-row': !isRowValid(rowData)}">
              <td>
                <p-dropdown [options]="formularioColumnas" appendTo="body"
                  placeholder="Seleccionar campo" optionLabel="controlLabel" optionValue="controlPath"
                  [(ngModel)]="rowData.campoFormulario" styleClass="w-full"></p-dropdown>
              </td>
              <td>
                <p-dropdown [options]="columnsTablaDinamica" appendTo="body"
                  placeholder="Seleccionar campo" optionLabel="name" optionValue="name"
                  [(ngModel)]="rowData.campoTablaDinamica" styleClass="w-full"></p-dropdown>
              </td>
              <td>
                <button pButton type="button" icon="pi pi-trash" class="p-button-danger" 
                  (click)="remove(rowData)" pTooltip="Eliminar" tooltipPosition="top"></button>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="3" class="text-center p-4">
                No hay configuraciones de llaves. Haga clic en "Agregar" para crear una nueva.
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
  </div>
  `,
  styles: [`
    .invalid-row {
      background-color: rgba(255, 0, 0, 0.05);
    }
  `]
})
export class ActAutomaticaLlavesConfigComponent {
  @Input() formularioColumnas !: IGetNombreColumnas[];
  @Input() columnsTablaDinamica !: IColumnDinamico[];

  llavesConfig: LlavesConfig[] = [];

  reset() {
    this.llavesConfig = [];
  }

  load(config: LlavesConfig[]) {
    this.llavesConfig = config;
  }

  add() {
    this.llavesConfig.push({
      campoFormulario: '',
      campoTablaDinamica: ''
    });
  }

  remove(rowData: LlavesConfig) {
    this.llavesConfig = this.llavesConfig.filter((item) => item !== rowData);
  }

  isRowValid(rowData: LlavesConfig): boolean {
    return rowData.campoFormulario != '' && rowData.campoTablaDinamica != '';
  }

  isValid(): boolean {    
    return this.llavesConfig.length > 0 && this.llavesConfig.every(item => this.isRowValid(item));
  }
}
